import React from "react";
import Seo from "../components/Seo";
import Hero from "../components/Heros/HeroMain";
import Footer from "../components/Footer";
import Tab from "../components/Tabs/MainTab";
import ScrollVelocity from "../components/ScrollVelocity";

const MainPage = () => {
    return (
        <>
            <Seo
                title="Databricks·Salesforce 공식 파트너"
                description="케이유융합소프트웨어연구센터(KUSRC)는 공식 Databricks·Salesforce 파트너로서 Lakehouse 기반 데이터 플랫폼 구축, Agentforce AI 자동화, CRM 디지털 전환을 지원합니다."
                path="/"
            />
            <Hero />
            <Tab />
            <ScrollVelocity />
            {/* <Cta title="서비스 도입이 필요하신가요?" reverse={false} /> */}
            <Footer />
        </>
    );
};

export default MainPage;
